const value = {
    newCategory: 'Create category',
    newValue: 'Create value',
    addButton: 'Create',
    saveButton: 'Save',
    withValue: 'Value',
    withTextField: 'Text field',
  };

export default value;
